<mat-card class="block" style="display: flex; justify-content: space-between; margin-bottom: 20px; align-items: center;">
 
  <div class="picture" *ngIf="ImagePathURL!=''">
    <img src="{{ ImagePathURL }}" />
  </div>
  
  <div class="">
    <h2>{{officeName}}</h2>
    <p>{{domainName}}</p>
  </div>
  

  <input #Input hidden="true" type="file" accept="image/*" (change)="fileChangeEvent($event)">
  <button mat-stroked-button color="primary" class="uploadButton" (click)="Input.click()">
    <mat-icon>upload_file</mat-icon> Upload logo
  </button>

  <button mat-button color="primary" [routerLink]="'/organization'">
    <mat-icon>arrow_back</mat-icon> Back
  </button>
</mat-card>


<!-- <input type="file" (change)="fileChangeEvent($event)" accept="image/*" /> -->

<!-- <image-cropper
  [imageChangedEvent]="imageChangedEvent"
  [maintainAspectRatio]="true"
  format="png"
  [transform]="transform"
  [style.display]="showCropper ? null : 'none'"
  (imageCropped)="imageCropped($event)"
  (imageLoaded)="imageLoaded()"
  (cropperReady)="cropperReady()"
  (loadImageFailed)="loadImageFailed()">
</image-cropper> -->

<!-- <image-cropper
    [imageChangedEvent]="imageChangedEvent"
    [maintainAspectRatio]="true"
    [aspectRatio]="4 / 3"
    [resizeToWidth]="128"
    format="png"
    (imageCropped)="imageCropped($event)"
    (imageLoaded)="imageLoaded()"
    (cropperReady)="cropperReady()"
    (loadImageFailed)="loadImageFailed()"   
    ></image-cropper>

<img [src]="croppedImage" /> -->

<!-- <input type="file" (change)="fileChangeEvent($event)" accept="image/*" /> -->


<!-- <button (click)="toggleAspectRatio()">
  Aspect ratio: {{ aspectRatio === 1 / 1 ? '1/1' : '16/5' }}
</button> -->
<mat-card class="imageOuter" *ngIf="showCropperDiv==true">

  <div class="imgadjuster">
    <div class="imageControls">


      <div class="d-flex">
        <mat-form-field appearance="fill" class="imageAspectRatio" >
          <mat-label>Aspect ratio</mat-label>
          <mat-select (selectionChange)="selectAspectRatio($event)">
            <mat-option value="1:1">1:1</mat-option>
            <mat-option value="1:2">1:2</mat-option>
            <mat-option value="4:3">4:3</mat-option>
            <mat-option value="16:9">16:9</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="freeHand">
          <button mat-stroked-button color="primary"  (click)="freeHand()"> Free Hand </button>
        </div>
      </div>

      <div class="controls">
        <button mat-icon-button color="primary" (click)="zoomIn()"><mat-icon>zoom_in</mat-icon></button>
        <button mat-icon-button color="primary" (click)="zoomOut()"><mat-icon>zoom_out</mat-icon></button>

        <button mat-icon-button color="primary" (click)="moveRight()"><mat-icon>chevron_left</mat-icon></button>
        <button mat-icon-button color="primary" (click)="moveLeft()"><mat-icon>chevron_right</mat-icon></button>

        <button mat-icon-button color="primary" (click)="moveBottom()"><mat-icon>expand_less</mat-icon></button>
        <button mat-icon-button color="primary" (click)="moveTop()"><mat-icon>expand_more</mat-icon></button>
      </div>


    </div>

    <div class="imagecropper">
      <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="maintainAspectRatio"
        [cropperMaxWidth]="300" [cropperMaxHeight]="150" [cropperMinWidth]="50" [cropperMinHeight]="50"
        [containWithinAspectRatio]="containWithinAspectRatio" [aspectRatio]="aspectRatio" [cropperMinWidth]="128"
        [onlyScaleDown]="true" [roundCropper]="false" [canvasRotation]="canvasRotation" [(transform)]="transform"
        [alignImage]="'center'" [hidden]="hidden" imageAltText="Alternative image text" output="base64" format="png"
        (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady1($event)"
        (loadImageFailed)="loadImageFailed()"></image-cropper>

    </div>

    <div class="actionButtons">
      <button (click)="resetImage()" mat-stroked-button color="warn" >Reset</button>
      <button *ngIf="croppedImage!=''" mat-stroked-button color="primary" (click)="cropImage()"> Save </button>  
    </div>
    <br>
    <p>Please maintain your logo size with in max-height 150px and max-width 300px.</p>    
  </div>

  <div class="imgPreview">
    <img [src]="croppedImage"/>   
  </div> 
  
</mat-card>

<mat-card class="block">

  <mat-tab-group mat-align-tabs="start" (selectedTabChange)="onTabClick($event)">
    <mat-tab label="{{orgOfficeName}} Info">
      <div class="orgname">



        <div class="bigblock">
          <div class="headerinfo">

            <h3>{{orgOfficeName}} Details</h3>

          </div>

          <div class="adminBLock">
            <div class="block">
              <button mat-icon-button class="editbtn" (click)="openDialogeditOrg(editorg)">
                <mat-icon>edit</mat-icon>
              </button>


              <div class="name">
                <!-- <label> Name</label> -->
                {{officeName}}
              </div>

              <div class="email">

                <p>{{domainName}}</p>
                <label>Organization Type</label>
              </div>


              <div class="email">
                <p>{{databaseType}}</p>
                <label>Database Type</label>
              </div>


              <div class="email">
                <p>{{databaseName}}</p>
                <label>Database Name</label>
              </div>

              <div class="email">
                <p>{{AddedOn| date:'d/MMM/y'}}</p>
                <label>Added On</label>
              </div>

              <div class="email mt-2" *ngIf="ActiveInactiveButton">
                <span></span>
                <mat-slide-toggle [(ngModel)]="isChecked" color="primary" (change)="UpdateActiveInactive($event)">
                  <span class="lbltag_active" *ngIf="isChecked">Active</span>
                  <span class="lbltag" *ngIf="!isChecked">Inactive</span>
                </mat-slide-toggle>
              </div>

            </div>
          </div>
        </div>



        <div class="bigblock">
          <div class="headerinfo">

            <h3>Representative</h3>

          </div>

          <div class="adminBLock">
            <div class="block">
              <button mat-icon-button class="editbtn" (click)="openDialogWithRef(myDialog)">
                <mat-icon>edit</mat-icon>
              </button>

              <div class="name">{{RepresentativefirstName}} {{RepresentativelastName}}</div>
              <div class="email">{{RepresentativeEmail}}<button color="primary" mat-icon-button>
                  <mat-icon>mail</mat-icon>
                </button> </div>
              <div class="phone">+1 {{RepresentativephoneNumber}} <button color="primary" mat-icon-button>
                  <mat-icon>call</mat-icon>
                </button> </div>
              <!-- <button mat-stroked-button color="primary" >Edit</button> -->
            </div>
          </div>
        </div>
      </div>



      <div class="bigblock">
        <div class="headerinfo">
          <h3>{{orgOfficeName}} Address</h3>
        </div>

        <div class="adminBlock" style="width: 100%; max-width: 600px;">

          <form class="example-form" [formGroup]="addUpdateAddressForm">

            <mat-form-field>
              <mat-label>Address line 1</mat-label>
              <input matInput placeholder="Address1" maxlength="100" name="description" formControlName="address1"
                required />
            </mat-form-field>

            <mat-form-field>
              <mat-label>Address line 2</mat-label>
              <input matInput placeholder="Address2" maxlength="100" name="description" formControlName="address2" />
            </mat-form-field>


            <div class="addState">

              <mat-form-field>
                <mat-select placeholder="Country List" formControlName="countryId"
                  (selectionChange)="getStateDropdownList()" [(ngModel)]="countrySelected" name="countryId">
                  <input type="text" #searchCountry placeholder="Search Country" matInput autocomplete="off"
                    (input)="onChangeCountry($event.target.value)">
                  <mat-option *ngFor="let country of countryList" [value]="country.countryID">
                    {{country.countryName}}
                  </mat-option>
                </mat-select>
              </mat-form-field>


              <mat-form-field class="mrlr20">
                <mat-select placeholder="State List" formControlName="stateId" (selectionChange)="getCityDropdownList()"
                  [(ngModel)]="stateSelected" name="stateId">
                  <input type="text" #searchState style="padding: 10px;" placeholder="Search State" matInput
                    autocomplete="off" (input)="onChangeState($event.target.value)">
                  <mat-option *ngFor="let state of stateList" [value]="state.stateID">
                    {{state.stateName}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field>
                <mat-select placeholder="City List" formControlName="cityId" [(ngModel)]="citySelected" name="cityId">
                  <input type="text" #searchCity placeholder="Search City" matInput autocomplete="off"
                    (input)="onChangeCity($event.target.value)">
                  <mat-option *ngFor="let city of cityList" [value]="city.cityID">
                    {{city.cityName}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

            </div>

            <div class="postal" style="width: 100%; max-width: 185px;">
              <mat-form-field>
                <mat-label>Postal Code</mat-label>
                <input matInput #postalCode maxlength="5" placeholder="Postal Code" formControlName="postalCode"
                  (keypress)="allowOnlyNumber($event)">
                <mat-hint align="end">{{postalCode.value.length}} / 5</mat-hint>
              </mat-form-field>
            </div>

          </form>
          <button color="primary" mat-flat-button style="margin-right:20px;"
            [disabled]="addUpdateAddressForm.invalid || !addUpdateAddressForm.dirty"
            (click)="addUpdateAddress(addUpdateAddressForm.value)"> Save </button>

        </div>

      </div>


    </mat-tab>


    <mat-tab label="Admin">

      <div class="bigblock">
        <div class="headerinfo">

          <h3>Admin</h3>

          <div class="toright">

            <span>

              <div *ngIf="isHeadOffice">
                <button mat-stroked-button color="primary" (click)="addUsersOrg(2)">
                  + Organization Admin
                </button>
                <button mat-stroked-button color="primary" (click)="addUsers(3)">
                  + Office Admin
                </button>
              </div>

              <div *ngIf="childOffice">
                <button mat-stroked-button color="primary" (click)="addUsers(3)">
                  + Office Admin
                </button>
              </div>

            </span>
          </div>
        </div>

        <div class="adminBLock">
          <mat-card class="block" *ngFor="let off of OfficeAdministratorList">
            <small>{{off.roleNames}}</small>
            <!-- <small *ngIf="off.roleLevel==2">Organization Admin</small>
            <small *ngIf="off.roleLevel==3">Office Admin</small> -->
            <div class="name">{{off.firstName}} {{off.lastName}}</div>
            <div class="email">{{off.email}} <button color="primary" mat-icon-button>
                <mat-icon>mail</mat-icon>
              </button> </div>
            <div class="phone">{{off.phoneNumber}} <button color="primary" mat-icon-button>
                <mat-icon>call</mat-icon>
              </button> </div>

            <div class="active">
              <mat-slide-toggle disabled="true" color="primary">Active</mat-slide-toggle>
            </div>

          </mat-card>

          <div *ngIf="OfficeAdministratorList.length==0">
            <p style="text-align: center; padding: 20px;">No Record Found</p>
          </div>

        </div>
      </div>

    </mat-tab>


    <mat-tab label="Module Access" class="">
      <p style="margin: 10px 0; padding-left: 19px; font-weight: 600;">Any changes here will reflect on next login. </p>


<!-- <div class="moduleAcess"> -->
 
<div class="table-header table-row">
    <div class="col_holder">
      <div class="td icon"></div>
      <div class="td">System Module</div>
      <div class="td">Organization Module</div>
      
    </div>
  </div>
  <div class="rowtable table-row" *ngFor="let row of SystemModuleList; let rowIndex = index">
    <div class="table-row">
     <div class="col_holder">
          <div class="td icon">           
            <span *ngIf="isRowClickable(rowIndex)">
            <span *ngIf="expanded[row.mainModuleName]"><button (click)="expanded[row.mainModuleName] = !expanded[row.mainModuleName]" mat-icon-button color="basic" ><mat-icon>expand_less</mat-icon></button></span>
            <span *ngIf="!expanded[row.mainModuleName]"><button (click)="expanded[row.mainModuleName] = !expanded[row.mainModuleName]" mat-icon-button color="basic" ><mat-icon>expand_more</mat-icon></button></span>
          </span>
        </div>
        <div class="td">
         <span class="fieldIcon popucheck">
          <mat-checkbox color="primary" [checked]="row.isAssign" [disabled]="row.isDisabled"
              (change)="ActiveOrgModule($event, row)">             
            </mat-checkbox>
          </span> 
          <span class="orgName">{{row.mainModuleName}}</span>        
          
        </div> 
       <div class="td">
        <mat-icon *ngIf="row.isAssign" style="color: rgb(84, 207, 84);">lock_open</mat-icon>
        <mat-icon *ngIf="!row.isAssign" style="color: rgb(151, 151, 151);">lock</mat-icon>
        {{row.orgModuleName}}

          <button *ngIf="row.isAssign" mat-icon-button class="editbtn"
             (click)="openDialogRenameModuleWithRef(renamemodule,row)">
            <mat-icon>edit</mat-icon>
         </button>
      </div> 
     </div>      
      <div [@detailExpand]="expanded[row.mainModuleName] ? 'expanded' : 'collapsed'">
      
        <div  class="child-row" *ngFor="let childrow of row.child">
          <div class="td icon"></div>
          <div class="td">
            <mat-icon color="primary">subdirectory_arrow_right</mat-icon>
             <span class="fieldIcon popucheck">
              
              <mat-checkbox color="primary" [checked]="childrow.isAssign" [disabled]="childrow.isDisabled"
               (change)="ActiveOrgModule($event, childrow)">             
             </mat-checkbox>
            </span>
            <span class="orgName">
              {{childrow.mainModuleName}}
            </span>
            
          </div> 
           <div class="td"><span class="orgName">
            {{childrow.orgModuleName}}
          <button *ngIf="childrow.isAssign" mat-icon-button class="editbtn"
             (click)="openDialogRenameModuleWithRef(renamemodule,childrow)">
            <mat-icon>edit</mat-icon>
         </button>
          </span>
          </div>     
        </div>
    </div>
    </div>
  </div>



<!-- </div> -->




        <!-- <div class="module">
          <ul>
            <li>
              <div class="moduleName">
                  <div class="table-header table-row">   
   
      <h4>System Module</h4>      
   
  </div>
  <div class="rowtable table-row" *ngFor="let row of SystemModuleList; let rowIndex = index">
    <div class="table-row">
     <div class="col_holder">
          <div class="systemModule">
             <mat-checkbox color="primary" [checked]="row.isAssign" [disabled]="row.isDisabled"
              (change)="ActiveOrgModule($event, row)">
              {{row.mainModuleName}}
            </mat-checkbox>
            <span *ngIf="isRowClickable(rowIndex)">
            <span *ngIf="expanded[row.mainModuleName]"><button (click)="expanded[row.mainModuleName] = !expanded[row.mainModuleName]" mat-icon-button color="basic" ><mat-icon>expand_less</mat-icon></button></span>
            <span *ngIf="!expanded[row.mainModuleName]"><button (click)="expanded[row.mainModuleName] = !expanded[row.mainModuleName]" mat-icon-button color="basic" ><mat-icon>expand_more</mat-icon></button></span>
          </span>
        </div>
       
         
     </div>      
       <div [@detailExpand]="expanded[row.mainModuleName] ? 'expanded' : 'collapsed'">      
        <div  class="child-row" *ngFor="let childrow of row.child">
          <div class="td icon"></div>         
          <div class="td">            
             <mat-checkbox color="primary">  {{childrow.mainModuleName}}</mat-checkbox>                   
          </div>          
        </div>
    </div>
    </div>
  </div>
              </div>

              <div class="moduleName">
                <h4>Organization Module</h4>
                <ng-container *ngFor="let mod of SystemModuleList">
                  <div class="selected">
                    <mat-icon *ngIf="mod.isAssign" style="color: rgb(84, 207, 84);">lock_open</mat-icon>
                    <mat-icon *ngIf="!mod.isAssign" style="color: rgb(151, 151, 151);">lock</mat-icon>
                    <p>
                      <span *ngIf="mod.isAssign" style="color: rgb(84, 207, 84);">{{mod.orgModuleName}}</span>
                      <span *ngIf="!mod.isAssign" style="color: rgb(151, 151, 151);">{{mod.orgModuleName}}</span>
                      
                    </p>

                  

                    <button *ngIf="mod.isAssign" mat-icon-button class="editbtn"
                      (click)="openDialogRenameModuleWithRef(renamemodule,mod)">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </div>

                    <div class="selected ">      
                        <div  class="child-row">
                          <mat-icon style="color: rgb(84, 207, 84);">lock_open</mat-icon>
                            <p> Document </p>     
                             <button  mat-icon-button class="editbtn"
                     >
                      <mat-icon>edit</mat-icon>
                    </button>   
                        </div>
                    </div>

                </ng-container>

              </div>

            </li>

          </ul>
        </div>       
       </div> -->

    </mat-tab>


    <mat-tab label="Mail" class="">      
      <div class="orgname">
        <div class="bigblock"> 

          <div class="headerinfo">
            <h3>SMTP Details</h3>
            <a [routerLink]="" (click)="showContent(stmpContaint)">Checkout the all server details</a>
          </div>      
  
          <mat-radio-group aria-label="Select an option" (change)="onSelectSMTP($event)">
            <mat-radio-button [checked]="checkedSMTPFlowtrics" value="1">Flowtrics SMTP</mat-radio-button>
            <mat-radio-button [checked]="checkedSMTPOffice" value="2">Custom SMTP</mat-radio-button>
            <mat-radio-button [checked]="checkedSMTPAPIOffice" value="3">SMTP API</mat-radio-button>
          </mat-radio-group>

          <div class="notOfficeSMTP" *ngIf="!showOfficeSMTP && showSendGrid==false">
              <p>Thank you for choosing Flowtrics SMTP for your email notifications. This configuration will enable the system to send emails seamlessly to your users and contacts. 
              </p>
              <h3>Upon selecting Flowtrics SMTP, the default sender address will be set to 'flowtrics@flowtrics.net'.</h3>
              <p>This address will be used when sending emails to your users and cores,contacts and companies.</p>
            
              <button  mat-flat-button color="primary" class="mt-20"
               (click)="addFlowtricsSMTP()">
               Save             
              </button>
         
            </div>

          <div *ngIf="showOfficeSMTP && showSendGrid==false" class="notOfficeSMTP">  
            <form class="example-form" [formGroup]="addOfficeSMTPForm">
  
              <mat-form-field>
                <mat-label>From Display Name</mat-label>
                <input matInput placeholder="From Display Name" maxlength="100" name="description" 
                formControlName="displayName" required />
              </mat-form-field>
  
              <mat-form-field>
                <mat-label>From Email Address</mat-label>
                <input matInput placeholder="From Email Address" maxlength="100" name="description"  
                formControlName="emailAddress" required/>
              </mat-form-field>
  
              <mat-form-field>
                <mat-label>SMTP Server</mat-label>
                <input matInput placeholder="SMTP Server" maxlength="100" name="description"  
                formControlName="smtpserver" required/>
              </mat-form-field>
           
              <mat-form-field>
                <mat-label>Port</mat-label>
                <input matInput placeholder="Port" maxlength="10" name="description" 
                formControlName="port" (keypress)="numberOnly($event)" required />
              </mat-form-field>
          
  
              <mat-form-field>
                <mat-label>Username</mat-label>
                <input matInput placeholder="Username" maxlength="100" name="description" 
                formControlName="userName" required />
              </mat-form-field>

              <mat-form-field>
                <mat-label>Password</mat-label>
                <input matInput [type]="hidenew ? 'password' : 'text'" placeholder="Password" maxlength="50" name="description"  
                formControlName="password" required/>
                <mat-icon matSuffix (click)="hidenew = !hidenew" [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hidenew">{{hidenew ? 'visibility_off' : 'visibility'}}
                </mat-icon> 
              </mat-form-field>

              <mat-checkbox [checked]="true" formControlName="ssl" class="example-margin">Use SSL</mat-checkbox>               

             <br>
              <p class=" mt-20">If receive email via flowtrics using their own smtp detail then please confirm.
             </p>

             <mat-form-field>
              <mat-label>Email</mat-label>
              <input matInput placeholder="Email" maxlength="100" name="description" 
              formControlName="testEmail" required />
            </mat-form-field>                     

            <button mat-flat-button color="primary" class="mt-20"
            [disabled]="addOfficeSMTPForm.invalid || !addOfficeSMTPForm.dirty" (click)="TestMail(addOfficeSMTPForm.value)">
              Test           
            </button>         

              <div class="d-flex mt-20 js" *ngIf="ShowTestMail">
                <button mat-stroked-button color="primary" (click)="IsTested(true)"><mat-icon>check</mat-icon> Yes, test mail received</button>
                <button mat-stroked-button color="warn" (click)="IsTested(false)"><mat-icon>close</mat-icon> No, test mail not receive</button>
              </div>                 
             
              <button *ngIf="ShowTestMail" mat-flat-button color="primary" class="mt-20" (click)="addOfficeSMTP(addOfficeSMTPForm.value)"
              [disabled]="addOfficeSMTPForm.invalid || !addOfficeSMTPForm.dirty">Save
              <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
              </mat-spinner></mat-icon>
              </button>

           </form>

          </div>
  
          <div *ngIf="showSendGrid==true" class="notOfficeSMTP">  
            <form class="example-form" [formGroup]="addSendGridSMTPForm">
  
              <mat-form-field>
                <mat-label>From Display Name</mat-label>
                <input matInput placeholder="From Display Name" maxlength="100" name="description" 
                formControlName="displayName" required />
              </mat-form-field>
  
              <mat-form-field>
                <mat-label>From Email Address</mat-label>
                <input matInput placeholder="From Email Address" maxlength="100" name="description"  
                formControlName="emailAddress" required/>
              </mat-form-field>
  
              <mat-form-field>
                <mat-label>API Key</mat-label>
                <input matInput placeholder="API Key" maxlength="100" name="description"  
                formControlName="apikey" required/>
              </mat-form-field>
                     

             <br>
              <p class=" mt-20">If receive email via smtp using their own smtp detail then please confirm.
             </p>

             <mat-form-field>
              <mat-label>Email</mat-label>
              <input matInput placeholder="Email" maxlength="100" name="description" 
              formControlName="testEmail" required />
            </mat-form-field>                     

            <button mat-flat-button color="primary" class="mt-20"
            [disabled]="addSendGridSMTPForm.invalid || !addSendGridSMTPForm.dirty" (click)="TestMailSendGrid(addSendGridSMTPForm.value)">
              Test           
            </button>         

              <div class="d-flex mt-20 js" *ngIf="ShowTestMail">
                <button mat-stroked-button color="primary" (click)="IsTestedAPI(true)"><mat-icon>check</mat-icon> Yes, test mail received</button>
                <button mat-stroked-button color="warn" (click)="IsTestedAPI(false)"><mat-icon>close</mat-icon> No, test mail not receive</button>
              </div>                 
             
              <button *ngIf="ShowTestMail" mat-flat-button color="primary" class="mt-20" (click)="addSMTPAPI(addSendGridSMTPForm.value)"
              [disabled]="addSendGridSMTPForm.invalid || !addSendGridSMTPForm.dirty">Save
              <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
              </mat-spinner></mat-icon>
              </button>

           </form>

          </div>

        </div>

        <div class="bigblock" *ngIf="showSignature">       
      
          <div class="headerinfo">
            <h3>Email Signature</h3>
          </div>
          
          <ckeditor (change)="CheckMessage($event)" editorUrl="https://cdn.ckeditor.com/4.14.0/full/ckeditor.js" 
            [config]="ckEditorConfig" [(ngModel)]="msg" [config]="editorConfig">
           </ckeditor>
  
           <button mat-flat-button class="mt-20" color="primary"
           (click)="addEmailSignature()" [disabled]="MessageButton">Save
            <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
            </mat-spinner></mat-icon>
           </button>
                  
        </div>

      </div>      

    </mat-tab>  
 
    <mat-tab label="Portal Configuration" class="">      
      <div class="portal_configuration">
        
        <div >
          <input #InputPortal hidden="true" type="file" accept="image/*" (change)="fileChangeEventForPortal($event)">
          <button mat-stroked-button color="primary" class="" (click)="InputPortal.click()">
            <mat-icon>upload_file</mat-icon> Upload portal background
          </button>&nbsp;&nbsp;
          <button *ngIf="ImageUploadURLforPortal!=''" mat-stroked-button color="primary" 
          (click)="uploadBackgroundImage()"> Save 
         </button> 
          <br>
          <br>
          <!-- <i>Please upload the high-resolution image for better viewing.</i> -->
          <i>1. Please upload the high-resolution image with minimum dimensions 1024x768 (Width x Height) for better viewing.</i><br>
          <i>2. This image will serve as the background during the selection of your office's entities within the guest portal.</i><br>
          <i>3. Max image size is 1 Mb and optimal size is 400 Kb.</i>
          <br>
        </div>

        
       
      

      </div>
      <div class="portal_configuration">
        <div  *ngIf="portalBg!=''">
          <br>
          <br>
          <img width="98%" src="{{ portalBg }}" />           
          <!-- <img src="https://images.unsplash.com/photo-1705591629142-9ba989fbc684?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" /> -->
        </div>
      </div>
    </mat-tab>  


    <mat-tab *ngIf="showImports==true" label="Imports" class="">      
      <h3>Import Forms</h3>
      <div >
        <p>From which office do you want to import forms into this office?</p>       
        <mat-form-field>
          <mat-label>Select Office</mat-label>
          <mat-select (selectionChange)="OnSelectOfficeforImport($event)" [(ngModel)]="officeIdforImport">
            <mat-option *ngFor="let sf of OfficeListforImport" [value]="sf.officeID">
              {{sf.officeName}} : {{sf.domainName}}
            </mat-option>
          </mat-select> 
        </mat-form-field>

        <p>From which user account of super admin's office should be Data be import?</p>       
        <mat-form-field>
          <mat-label>Select User</mat-label>
          <mat-select (selectionChange)="OnSelectUseraccountImport($event)" [(ngModel)]="userIdforImport">
            <mat-option *ngFor="let off of SelectedOfficeUser" [value]="off.uuid">
              {{off.firstName}} {{off.lastName}}  ({{off.roleNames}})
            </mat-option>
          </mat-select> 
        </mat-form-field>

        <p>To which admin user account of this office should be forms be imported?</p>       
        <mat-form-field>
          <mat-label>Select Admin User</mat-label>
          <mat-select (selectionChange)="OnSelectAdminforImport($event)" [(ngModel)]="adminIdforImport">
            <mat-option *ngFor="let off of OfficeAdministratorList" [value]="off.uuid">
              {{off.firstName}} {{off.lastName}}  ({{off.roleNames}})
            </mat-option>
          </mat-select> 
        </mat-form-field>

        <p>What folder name you want to keep for these imported forms</p>   
        <mat-form-field>         
          <input matInput placeholder="Enter folder name" maxlength="100" [(ngModel)]="folderNameForImport"/>
        </mat-form-field>
      </div>
     
      <button  mat-flat-button color="primary" (click)="importForms()">
         Import Forms             
       </button> &nbsp;&nbsp;&nbsp;

       <button  mat-flat-button color="primary" (click)="importFileManagerFolder()">
        Import File Manager Folders           
      </button> &nbsp;&nbsp;&nbsp;

      <button  mat-flat-button color="primary" (click)="importAIQuestion()">
        Import AI Question       
      </button>&nbsp;&nbsp;&nbsp;

      <button  mat-flat-button color="primary" (click)="importAIFieldTemplates()">
        Import AI Field Templates
      </button> &nbsp;&nbsp;&nbsp;

       <button style="margin-top: 20px;"  mat-flat-button color="primary" (click)="importAIAutomationTemplates()">
        Import AI Automation Template
      </button>

    </mat-tab>  

  </mat-tab-group>
  
</mat-card>

<app-create-user *ngIf="showUserForm" (closeSidePanel)="closeSidePanel($event)"
  (closeSidePanelAfterSave)="closeSidePanelAfterSave($event)" [ngClass]="{ open: showUserForm }"
  [SelectedRole]="SelectedRole">
</app-create-user>

<app-create-userOrg *ngIf="showUserFormOrg" (closeSidePanel)="closeSidePanel($event)"
  (closeSidePanelAfterSave)="closeSidePanelAfterSave($event)" [ngClass]="{ open: showUserFormOrg }"
  [SelectedRole]="SelectedRole">
</app-create-userOrg>

<ng-template #myDialog>
  <form [formGroup]="RepresentativeformDialog">
    <h2 mat-dialog-title>
      Edit Representative
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content class="mat-typography">
      <div class="d-flex">
        <mat-form-field>
          <mat-label>First Name</mat-label>
          <input matInput placeholder="First Name" maxlength="30" formControlName="representativePersonFirstName">
          <mat-error>
            This field is required
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label> Last Name</mat-label>
          <input matInput placeholder="Last Name" maxlength="30" formControlName="representativePersonLastName">
          <mat-error>
            This field is required
          </mat-error>
        </mat-form-field>
      </div>

      <mat-form-field>
        <mat-label> Email</mat-label>
        <input matInput placeholder="Email" maxlength="50" formControlName="representativePersonemail">
    
      </mat-form-field>

      <mat-form-field>
        <mat-label> Phone</mat-label>
        <span matPrefix>+1 &nbsp;</span>
        <input matInput placeholder="Phone" maxlength="10" mask="(000) 000-0000"
          formControlName="representativePersonphoneNumber">
        <!-- <mat-error>{{getPhoneErrorMessage()}}</mat-error> -->
      </mat-form-field>

    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions">
      <button mat-button (click)="close()">Cancel</button>
      <button mat-flat-button color="primary"
        [disabled]="RepresentativeformDialog.invalid || !RepresentativeformDialog.dirty"
        (click)="UpdateRepresentativeDetails(RepresentativeformDialog.value)">Update
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>

  </form>
</ng-template>


<ng-template #renamemodule>
  <form [formGroup]="RenameformDialog">
    <h2 mat-dialog-title>
      Organization Module
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>
    <mat-dialog-content class="mat-typography">
      <mat-form-field>
        <mat-label>Module Name</mat-label>
        <input matInput placeholder="Module Name" maxlength="30" formControlName="orgModuleName">
        <mat-error>
          This field is required
        </mat-error>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions class="dialog-actions">
      <button mat-button (click)="close()">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="RenameformDialog.invalid || !RenameformDialog.dirty"
        (click)="RenameOrgModule(RenameformDialog.value)">Update
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>



<ng-template #editorg>
  <form [formGroup]="RenameOrgformDialog">
    <h2 mat-dialog-title>
      Edit {{orgOfficeName}}
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content class="mat-typography">
      <div class="d-flex">
        <mat-form-field>
          <mat-label>{{orgOfficeName}} Name</mat-label>
          <input matInput placeholder="{{orgOfficeName}} Name" maxlength="30" formControlName="officeName">
          <mat-error>
            This field is required
          </mat-error>
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="dialog-actions">
      <button mat-button (click)="close()">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="RenameOrgformDialog.invalid || !RenameOrgformDialog.dirty"
        (click)="RenameOrganizationName(RenameOrgformDialog.value)">Update
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>


<ng-template #stmpContaint>
  
    <h2 mat-dialog-title>   
      Server Details
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content class="mat-typography">
      <div class="mailLinks">
        <h2>Gmail (Google) Accounts With 1-Step-Verification</h2>
        Easily use your Google account to configure your email by following the simple steps:
        <ul class="">
          <li><p>Sign into your Google account.</p></li>
          <li><p> Go to the "Less secure apps" section in My Account.</p></li>
          <li><p><span>Next to "Access for less secure apps," select Turn on. (Note to Google Apps users: </span> This setting is hidden if your administrator has locked less secure app account access.)</p></li>
          <li><p>Return to the Outbound Email page in AcctFusion (close this modal) and fill in all of the required information. You may then send a Test or press Save.</p></li>
          <li><p><span>From Display Name:</span> YOUR NAME</p></li>
          <li><p><span>From Email Address:</span> YOUR EMAIL ADDRESS</p></li>
          <li><p><span>SMTP Server:</span> smtp.gmail.com</p></li>
          <li><p><span>Port:</span> 587 </p></li>
          <li><p><span>User Name:</span> YOUR EMAIL ADDRESS</p></li>
          <li><p><span>Password:</span> YOUR PASSWORD</p></li>
          <li><p><span>Requires SSL:</span> CHECKED</p></li>            
        </ul>
      </div>

      <div class="mailLinks">
        <h2>Gmail (Google) Accounts With 2-Step-Verification</h2>
        Note: If you use 2-Step-Verification and are seeing a "password incorrect" error when trying to access your Google Account, an App Password may solve the problem.
        <ul class="">
          <li><p>Go to your Google Account.</p></li>
          <li><p> On the left navigation panel, choose Security.</p></li>
          <li><p> On the "Signing in to Google" panel, choose App Passwords. If you don’t see this option:</p></li>
          <li><p> 2-Step Verification is set up for security keys only</p></li>
          <li><p> Your account is through work, school, or other organization</p></li>
          <li><p> You’ve turned on Advanced Protection for your account</p></li>
          <li><p> At the bottom, choose Select app and choose "Other" and type "AcctFusion".</p></li>
          <li><p> Choose Generate.</p></li>
          <li><p> The App Password is the 16-character code in the yellow bar. Copy the new App Password to use as the password within AcctFusion's Outbound Email page.</p></li>
          <li><p> Choose Done.</p></li>
          <li><p> Return to the Outbound Email page in AcctFusion (close this modal) and fill in all of the required information. You may then send a Test or press Save.</p></li>
          <li><p><span>From Display Name:</span> YOUR NAME</p></li>
          <li><p><span>From Email Address:</span> YOUR EMAIL ADDRESS</p></li>
          <li><p><span>SMTP Server:</span> smtp.gmail.com</p></li>
          <li><p><span>Port:</span> 587 </p></li>
          <li><p><span>User Name:</span> YOUR EMAIL ADDRESS</p></li>
          <li><p><span>Password:</span> YOUR PASSWORD</p></li>
          <li><p><span>Requires SSL:</span> CHECKED</p></li>            
        </ul>
      </div>
      
      <div class="mailLinks">
        <h2>Outlook.com (Microsoft)</h2>
        <ul class="">
          <li><p><span>SMTP Server:</span> smtpmail.outlook.com</p></li>
          <li><p><span>Port:</span> 587 </p></li>
          <li><p><span>Requires SSL:</span> Yes (STARTTLS)</p></li>
          <li><p><span>Requires Authentication:</span> Yes</p></li>          
        </ul>
      </div>


<!--      
      
    3. Yahoo Mail
        SMTP Server: smtp.mail.yahoo.com
        Port: 465
        Requires SSL: Yes
        Requires Authentication: Yes
    
    4. Apple iCloud
        SMTP Server: smtp.mail.me.com
        Port: 587
        Requires SSL: Yes (STARTTLS)
        Requires Authentication: Yes
    
    5. AOL Mail
        SMTP Server: smtp.aol.com
        Port: 587
        Requires SSL: Yes (STARTTLS)
        Requires Authentication: Yes
    
    6. Zoho Mail
        SMTP Server: smtp.zoho.com
        Port: 587
        Requires SSL: Yes (STARTTLS)
        Requires Authentication: Yes
    
    7. Mail.com
        SMTP Server: smtp.mail.com
        Port: 587
        Requires SSL: Yes (STARTTLS)
        Requires Authentication: Yes
    
    8. Office 365 (Microsoft)
        SMTP Server: smtp.office365.com
        Port: 587
        Requires SSL: Yes (STARTTLS)
        Requires Authentication: Yes
    
    9. Exchange Server (Microsoft)
        SMTP Server: Depends on the specific Exchange server configuration.
        Port: Typically 587
        Requires SSL: Yes (STARTTLS)
        Requires Authentication: Yes
    
    10. SendGrid
         SMTP Server: smtp.sendgrid.net
         Port: 587
         Requires SSL: Yes (STARTTLS)
         Requires Authentication: Yes -->
      
    </mat-dialog-content>
    <mat-dialog-actions class="dialog-actions">
      <button mat-button (click)="close()">Cancel</button>     
    </mat-dialog-actions>

</ng-template>

<div class="progress-loader" *ngIf="spinnerLoader">

  <div class="lds-ripple" ><div></div><div></div></div>
</div>

<style>
  .cke_notifications_area { display: none;}
</style>

<style>
  .cke_notification { display: none; }
</style>
<style>
  .cke_notification_warning { display: none; }
</style>
<!-- <app-loader></app-loader> -->